module.exports = __webpack_public_path__ + "img/red-checked-tick.2ea08d00.svg";